/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.0.0 (NJsonSchema v10.1.18.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ClientBase } from "msg-swagger";
var SentrySettingsClient = /** @class */ (function (_super) {
    __extends(SentrySettingsClient, _super);
    function SentrySettingsClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    SentrySettingsClient.prototype.get = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/sentrysettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(function (transformedOptions_) {
            return _this.http.fetch(url_, transformedOptions_);
        }).then(function (_response) {
            return _this.processGet(_response);
        });
    };
    SentrySettingsClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SentryApplicationSettingsDTO.fromJS(resultData200) : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return SentrySettingsClient;
}(ClientBase));
export { SentrySettingsClient };
var SentryApplicationSettingsDTO = /** @class */ (function () {
    function SentryApplicationSettingsDTO(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SentryApplicationSettingsDTO.prototype.init = function (_data) {
        if (_data) {
            this.uri = _data["Uri"];
            this.clientId = _data["ClientId"];
            if (Array.isArray(_data["RequestedScopes"])) {
                this.requestedScopes = [];
                for (var _i = 0, _a = _data["RequestedScopes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.requestedScopes.push(item);
                }
            }
            this.redirectUri = _data["RedirectUri"];
            this.postLogoutUri = _data["PostLogoutUri"];
            this.silentRenewUri = _data["SilentRenewUri"];
        }
    };
    SentryApplicationSettingsDTO.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SentryApplicationSettingsDTO();
        result.init(data);
        return result;
    };
    SentryApplicationSettingsDTO.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["Uri"] = this.uri;
        data["ClientId"] = this.clientId;
        if (Array.isArray(this.requestedScopes)) {
            data["RequestedScopes"] = [];
            for (var _i = 0, _a = this.requestedScopes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["RequestedScopes"].push(item);
            }
        }
        data["RedirectUri"] = this.redirectUri;
        data["PostLogoutUri"] = this.postLogoutUri;
        data["SilentRenewUri"] = this.silentRenewUri;
        return data;
    };
    return SentryApplicationSettingsDTO;
}());
export { SentryApplicationSettingsDTO };
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
export { SwaggerException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}
//# sourceMappingURL=generated.js.map